import { AxiosResponse } from 'axios';
import i18n from 'i18next';
import ChatApiInstance from 'api/Chat/ChatApiInstance';
import { LOCAL_STORAGE_AUTH_TOKEN } from 'common/localStorageKeys';
import { IParams } from 'services/common/@types';
import ApiInstance from 'api/Base';
import { API_URL, CHAT_API_URL } from 'config';
import {
  URL_ASK,
  URL_CREATE_TOKEN,
  URL_HANDLE_EXTERNAL_USER_PROCESS,
  URL_USER_VALIDATION,
  URL_VALIDATE_USER_EVENTS_MERGE,
} from './Chat.values';
import {
  EIEntityTypes,
  IServiceChatAskProps,
  IServiceChatCreateTokenProps,
  IServiceChatValidateUserProps,
} from './@types';

class ChatService {
  static instance: ChatService;

  static getInstance(): ChatService {
    if (!ChatService.instance) ChatService.instance = new ChatService();
    return ChatService.instance;
  }

  static ask = ({
    signal,
    params,
    question,
    months,
    isDefaultMonths,
    type,
    skillId,
    onDownloadProgress,
  }: IServiceChatAskProps): Promise<AxiosResponse> =>
    ChatApiInstance.post(
      URL_ASK,
      {
        entity_type: type || EIEntityTypes.BABY,
        skill_id: skillId,
        locale: params?.locale || i18n.language,
        months,
        isDefaultMonths,
        question,
      },
      {
        // onDownloadProgress: (progressEvent) => {
        //   console.info(progressEvent?.event?.currentTarget?.response?.split('[*R_END*]')[0]);
        // },
        onDownloadProgress: (progressEvent) => {
          onDownloadProgress?.(progressEvent);
        },
        signal,
        responseType: 'stream',
        headers: {
          // 'Content-Type': 'text/even-stream; charset=utf-8',
        },
        params,
      },
    );

  static createChatToken = ({ signal, params, chatUserId }: IServiceChatCreateTokenProps): Promise<AxiosResponse> =>
    ApiInstance.post(
      URL_CREATE_TOKEN,
      {
        chat_user_id: chatUserId,
      },
      {
        signal,
        headers: {
          apiVersion: API_URL.versions.V5,
          Authorization: CHAT_API_URL.token,
        },
        // headers: {
        //   // 'Content-Type': 'text/even-stream; charset=utf-8',
        // },
        params,
      },
    );

  static validateUser = ({
    signal,
    params,
    accessCode,
    email,
    name,
    lastname,
    token,
    fbUUID,
    fbc,
    fbp,
  }: IServiceChatValidateUserProps): Promise<AxiosResponse> =>
    ApiInstance.post(
      URL_USER_VALIDATION,
      {
        access_code: accessCode,
        email,
        name,
        lastname,
        fb_event_id: fbUUID,
        fbc,
        fbp,
      },
      {
        signal,
        headers: {
          apiVersion: API_URL.versions.V5,
          Authorization: token,
          isFatal: false,
        },
        params,
      },
    );

  static validateUserEventsMerge = ({ signal }: IParams): Promise<AxiosResponse> =>
    ApiInstance.get(URL_VALIDATE_USER_EVENTS_MERGE, {
      signal,
      headers: {
        apiVersion: API_URL.versions.V5,
        Authorization: window.localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN),
      },
    });

  static externalUserProcess = ({ signal }: IParams): Promise<AxiosResponse> =>
    ApiInstance.post(
      URL_HANDLE_EXTERNAL_USER_PROCESS,
      {},
      {
        signal,
        headers: {
          apiVersion: API_URL.versions.V5,
          // Authorization: getChatUser().paymentToken,
          Authorization: window.localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN),
        },
      },
    );
}

export default ChatService;
